export namespace FileUpload {
  export interface Document {
    id: number;
    file: File | null;
    title: string;
    selected: boolean;
    serverId: number | null;
  }
}
